<div
  class="flex flex-row gap-2 bg-light-0 w-full h-11 px-2 py-1.5 rounded-full shadow justify-between"
>
  @for (tab of tabs; track $index) {
  <div
    class="flex flex-col justify-center items-center font-semibold text-sm text-light-200 rounded-full grow cursor-pointer hover:bg-blue-200"
    [ngClass]="{ 'bg-blue-100! text-light-0!': activeTab === $index }"
    (click)="onTabClick($index)"
  >
    {{ tab }}
  </div>
  }
</div>
